import { useEffect, useState } from 'react'

const useIsUsedOnBorne = (instanceId?: string): boolean => {
  const [current, setCurrent] = useState<boolean>(false)

  const handleChange = (e: CustomEvent): void => {
    if (instanceId) {
      e.detail.instanceId === instanceId && setCurrent(e.detail.value)
    } else {
      setCurrent(e.detail.value)
    }
  }

  useEffect(() => {
    document.addEventListener('retorik_isUsedOnBorne', (e) => handleChange(e))
    // Dispatch event on mount to get the updated value in stead of the default one
    document.dispatchEvent(new Event('retorik_call_isUsedOnBorne'))

    return () => {
      document.removeEventListener('retorik_isUsedOnBorne', (e) => handleChange(e))
    }
  }, [])

  return current
}

export default useIsUsedOnBorne
